import { Modes } from '@utils/enums/Modes.enum';
import { useMemo } from 'react';
import CommonConfiguration from '@common/CommonConfiguration';

function EmbeddedAppWrapper() {
  const basePath = useMemo(
    () => window.luxOB?.configurations?.basePath || '/',
    [],
  );
  return (
    <CommonConfiguration
      basePath={basePath}
      mode={Modes.EMBEDDED}
      practiceId={window.luxOB?.configurations?.storeNumber}
      providerId={window.luxOB?.configurations?.providerId}
      appointmentType={window.luxOB?.configurations?.appointmentType}
      brandName={window.luxOB?.configurations?.brandName}
      jwtToken={window.luxOB?.configurations?.jwtToken}
      infoUser={window.luxOB?.configurations?.infoUser}
      environmentConfig={window.luxOB?.configurations?.environmentConfig}
      hideHeader={window.luxOB?.configurations?.hideHeader}
      collapsableMobileBookingDetails={
        window.luxOB?.configurations?.collapsableMobileBookingDetails
      }
      appointmentId={window.luxOB?.configurations?.appointmentId}
      flowMode={window.luxOB?.configurations?.flowMode}
      integrationMode={window.luxOB?.configurations?.integrationMode}
      rescheduleUrl={window.luxOB?.configurations?.rescheduleURL}
      cancelUrl={window.luxOB?.configurations?.cancelURL}
      pageCountry={window.luxOB?.configurations?.pageCountry}
      pageLanguage={window.luxOB?.configurations?.pageLanguage}
      links={window.luxOB?.configurations?.links}
      hideBackToBrandHomePage={
        window.luxOB?.configurations?.hideBackToBrandHomePage
      }
      refid={window.luxOB?.configurations?.refid}
    />
  );
}
export default EmbeddedAppWrapper;
